import React from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon, HomeIcon } from "lucide-react";

const Breadcrumb = ({ items }) => {
  return (
    <nav className="flex items-center space-x-1 sm:space-x-2 text-xs sm:text-sm text-gray-600 mb-4 sm:mb-6 overflow-x-auto">
      {/* Home Link */}
      <Link 
        to="/" 
        className="flex items-center space-x-1 hover:text-blue-600 transition-colors flex-shrink-0"
      >
        <HomeIcon className="w-3 h-3 sm:w-4 sm:h-4" />
        <span className="hidden sm:inline">Home</span>
        <span className="sm:hidden">🏠</span>
      </Link>
      
      {/* Breadcrumb Items */}
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRightIcon className="w-3 h-3 sm:w-4 sm:h-4 text-gray-400 flex-shrink-0" />
          {item.href ? (
            <Link 
              to={item.href} 
              className="hover:text-blue-600 transition-colors whitespace-nowrap"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-900 font-medium whitespace-nowrap">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;